import { PermissionLight } from '../../../store/redux/reducers/permissionsSlice'
import { Box } from '@mui/system'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material'
import CollapsibleSection from '../../Button/CollapsibleSection'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLeftPadding } from '../../../store/redux/hooks'

const PermissionInfiniteScroll = ({
  displayedPermissions,
  fetchMore,
  hasMore,
  selectedPermissions,
  handlePermissionCheck,
}: {
  displayedPermissions: PermissionLight[]
  fetchMore: () => void
  hasMore: boolean
  selectedPermissions: string[]
  handlePermissionCheck: (event: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const { t } = useTranslation()
  const leftPadding = useLeftPadding()
  return (
    <CollapsibleSection text={t('page.adminsPage.filtering.permissions')}>
      <Box
        sx={{
          height: 150,
          overflowY: 'auto',
          overflowX: 'hidden',
          '::-webkit-scrollbar': {
            width: '6px',
            backgroundColor: 'background.elevation5',
            borderRadius: '10px',
            ml: 1,
          },
          '::-webkit-scrollbar-thumb': {
            backgroundColor: 'secondary.main',
            borderRadius: '10px',
            ml: 1,
          },
        }}
        id="scrollableDivPermissions"
      >
        <InfiniteScroll
          dataLength={displayedPermissions.length}
          next={fetchMore}
          hasMore={hasMore}
          loader={
            <span>
              <i>{t('components.infiniteScroll.loading')}</i>
            </span>
          }
          scrollableTarget={'scrollableDivPermissions'}
          style={{ overflowX: 'hidden', display: 'flex', flexDirection: 'column' }}
          endMessage={
            <Typography variant="body2" align="center" paddingY={2}>
              <i>{t('components.infiniteScroll.endMessage.permissions')}</i>
            </Typography>
          }
        >
          {displayedPermissions.map((permission, index) => (
            <Tooltip
              title={permission.id}
              placement={'right'}
              key={`${permission.id}-${index}-permission-filtering-menu-item-tooltip`}
            >
              <FormControlLabel
                sx={{ pl: leftPadding }}
                control={
                  <Checkbox
                    value={permission.id}
                    checked={selectedPermissions.includes(permission.id)}
                    onChange={handlePermissionCheck}
                  />
                }
                label={
                  <Typography
                    sx={{
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {permission.id}
                  </Typography>
                }
              />
            </Tooltip>
          ))}
        </InfiniteScroll>
      </Box>
    </CollapsibleSection>
  )
}

export default PermissionInfiniteScroll
